import { render, staticRenderFns } from "./JobSafetyTasksManagerWidget.vue?vue&type=template&id=65c91610&scoped=true"
import script from "./JobSafetyTasksManagerWidget.vue?vue&type=script&lang=js"
export * from "./JobSafetyTasksManagerWidget.vue?vue&type=script&lang=js"
import style0 from "./JobSafetyTasksManagerWidget.vue?vue&type=style&index=0&id=65c91610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c91610",
  null
  
)

export default component.exports